<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-center justify-between">
      <h2 class="text-base font-semibold text-slate-900">{{ title }}</h2>
      <button
        v-permission="'product:category:add'"
        v-if="showAddButton"
        @click="$emit('add')"
        class="rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
      >
        新增类型
      </button>
    </div>
    <p v-if="description" class="mt-2 text-xs text-slate-500">{{ description }}</p>

    <div v-if="loading" class="mt-4 space-y-3">
      <div v-for="n in 3" :key="n" class="h-16 rounded-xl border border-slate-200 bg-slate-50"></div>
    </div>

    <div v-else class="mt-4 space-y-3">
      <div
        v-for="category in categories"
        :key="category.id"
        @click="$emit('select', category.id)"
        :class="[
          'flex cursor-pointer items-center justify-between rounded-xl border p-4 transition',
          selectedCategoryId && Number(selectedCategoryId) === category.id
            ? 'border-primary-300 bg-primary-50/70 ring-1 ring-primary-200'
            : 'border-slate-200 bg-slate-50/70 hover:bg-slate-50'
        ]"
      >
        <div class="flex items-center gap-3">
          <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-white overflow-hidden">
            <img
              v-if="category.icon && !isSvgPath(category.icon)"
              :src="resolveFileUrl(category.icon)"
              class="h-full w-full object-cover"
              alt=""
            >
            <svg v-else class="h-5 w-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path :d="(category.icon && isSvgPath(category.icon)) ? category.icon : defaultIcon" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </svg>
          </div>
          <div>
            <div class="text-sm font-medium text-slate-900">{{ category.name }}</div>
            <div class="mt-1 flex items-center gap-2 text-xs text-slate-500">
              <span>{{ category.status === 1 ? '启用' : '停用' }}</span>
            </div>
          </div>
        </div>
        <div v-if="showActions" class="flex items-center gap-2">
          <button
            v-permission="'product:category:edit'"
            @click.stop="$emit('edit', category)"
            class="p-1.5 text-slate-400 hover:text-primary-600 transition-colors"
            title="编辑"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
            </svg>
          </button>
          <button
            v-permission="'product:category:delete'"
            @click.stop="$emit('delete', category)"
            class="p-1.5 text-slate-400 hover:text-red-600 transition-colors"
            title="删除"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </div>
      </div>

      <div v-if="!categories.length" class="rounded-xl border border-dashed border-slate-200 p-6 text-center text-sm text-slate-500">
        暂无类型数据
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  categories: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  selectedCategoryId: {
    type: [String, Number],
    default: ''
  },
  title: {
    type: String,
    default: '产品类型管理'
  },
  description: {
    type: String,
    default: '删除前会校验，类型下存在产品将无法删除。'
  },
  showAddButton: {
    type: Boolean,
    default: true
  },
  showActions: {
    type: Boolean,
    default: true
  }
})

defineEmits(['add', 'edit', 'delete', 'select'])

const defaultIcon = 'M12 4v16m8-8H4'

const isSvgPath = (icon) => {
  if (!icon) return false
  return /^[MLHVCSQTAZmlhvcsqtaz\d\s.,-]+$/.test(icon.trim())
}

const resolveFileUrl = (fileKey) => {
  if (!fileKey) return ''
  if (/^https?:\/\//i.test(fileKey)) return fileKey
  return `${process.env.VUE_APP_API_BASE_URL || ''}/${fileKey}`.replace(/\/+/g, '/').replace(':/', '://')
}
</script>
